export default function riskAdminDirective() {
  return {
    template: require('./risk-admin.html'),
    controller: 'RiskAdminController',
    controllerAs: 'riskAdminVM',
    bindToController: true,
    replace: true,
  };
}
